import React, { useEffect, useState } from 'react';
import styles from './OrdersDelayList.module.css';
import { BACKEND_URL } from '../config';

export default function OrdersDelayList({ range }) {
  const [orders, setOrders] = useState([]);
  const [showAll, setShowAll] = useState(false);
  const [loading, setLoading] = useState(false);

  const fetchOrders = (all = false) => {
    setLoading(true);
    const q = all ? `${BACKEND_URL}/api/report/orders-delay?range=${range}` : `${BACKEND_URL}/api/report/orders-delay?range=${range}&limit=10`;
    fetch(q)
      .then((res) => res.json())
      .then((data) => setOrders(Array.isArray(data) ? data : []))
      .catch(console.error)
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    fetchOrders(showAll);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [range, showAll]);

  return (
    <div className={styles.ordersDelayListContainer}>
      <div className={styles.header}>
        <h3 className={styles.title}>Orders Delay (Created vs Accepted)</h3>
        <button
          className={styles.button}
          onClick={() => setShowAll((s) => !s)}
        >
          {showAll ? 'Collapse' : 'Show all'}
        </button>
      </div>

      {loading ? (
        <p className={styles.loadingText}>Loading...</p>
      ) : (
        <div className={styles.tableContainer}>
          <table className={styles.table}>
            <thead className={styles.tableHead}>
              <tr>
                <th className={styles.tableHeadTh}>Branch</th>
                <th className={styles.tableHeadTh}>Order Number</th>
                <th className={styles.tableHeadTh}>Assigned Driver</th>
                <th className={styles.tableHeadTh}>Time Delay</th>
              </tr>
            </thead>
            <tbody>
              {orders.length === 0 ? (
                <tr><td colSpan="4" className={styles.noDataCell}>No data</td></tr>
              ) : (
                orders.map((o, idx) => (
                  <tr key={idx} className={styles.tableRow}>
                    <td className={styles.branchName}>{o.branch_name}</td>
                    <td className={styles.tableData}>{o.order_number}</td>
                    <td className={styles.tableData}>{o.driver_name || 'Unassigned'}</td>
                    <td className={styles.tableData}>{o.time_delay || '-'}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
